export default __webpack_public_path__ + "static/jingles-2e14271caf975e1b9ee897fb43236818.jpeg";